/**
 * This class allows side scrolling of an element via drag. It also exposes
 * left and right scrolling functions that can be called from anywhere.
 * The class must receive an html element as argument in its constructor when instantiating
 */
export class HorizontalScroller {
  static SCROLL_SPEED = 1;

  static SCROLL_DISTANCE = 450; // how many pixes should be scrolled (generally onClick, not drag)

  constructor(scrollableElement) {
    if (!scrollableElement) {
      throw new Error(
        'Cannot instantiate HorizontalScroller without a scrollable element'
      );
    }

    this.target = scrollableElement;
    this.isMouseDown = null;
    this.startX = null;
    this.scrollLeft = null;
  }

  /**
   * Prepares instance from scrolling. Intended for onMouseDown of element
   */
  activateScrolling = (evt) => {
    this.isMouseDown = true;
    this.startX = evt.pageX - this.target.offsetLeft;
    this.scrollLeft = this.target.scrollLeft;
  };

  /**
   * Turn off flag that allows scrolling
   */
  deactivateScrolling = () => {
    this.isMouseDown = false;
  };

  /**
   * Does actual scrolling based on mouse drag
   */
  onMouseMove = (evt) => {
    if (!this.isMouseDown) return;

    evt.preventDefault();
    const x = evt.pageX - this.target.offsetLeft;
    const walk = (x - this.startX) * HorizontalScroller.SCROLL_SPEED;
    this.target.scrollLeft = this.scrollLeft - walk;
  };

  start = () => {
    this.target.addEventListener('mousedown', this.activateScrolling);
    this.target.addEventListener('mouseup', this.deactivateScrolling);
    this.target.addEventListener('mouseleave', this.deactivateScrolling);
    this.target.addEventListener('mousemove', this.onMouseMove);
  };

  end = () => {
    this.target.removeEventListener('mousedown', this.activateScrolling);
    this.target.removeEventListener('mouseup', this.deactivateScrolling);
    this.target.removeEventListener('mouseleave', this.deactivateScrolling);
    this.target.removeEventListener('mousemove', this.onMouseMove);
  };

  /**
   * Intended for onClick events. Will scroll element to the left
   */
  left = () => {
    this.target.scrollBy({
      left: -HorizontalScroller.SCROLL_DISTANCE,
      behavior: 'smooth',
    });
  };

  /**
   * Intended for onClick events. Will scroll element to the right
   */
  right = () => {
    this.target.scrollBy({
      left: HorizontalScroller.SCROLL_DISTANCE,
      behavior: 'smooth',
    });
  };
}
